import { createContext } from "react";
import type { VideoTypes } from "@bloomberg/media-ui-av";

export const DEFAULT_VISIBILITY_THRESHOLD = 0.5;

const parseVideoEnv = (): VideoTypes.PlayerEnvironments => {
    let env;

    switch (process.env.NEXT_PUBLIC_VIDEO_ENV) {
        case "local":
            env = "local";
            break;
        case "staging":
            env = "staging";
            break;
        default:
            env = "production";
    }

    return env as VideoTypes.PlayerEnvironments;
};

export interface VideoPlayerContext {
    autoplay?: boolean;
    env?: VideoTypes.PlayerEnvironments;
    loadSuggestions?: boolean;
    options?: Partial<VideoTypes.CombinedPlaylistPlayerOptions>;
    preloadThreshold?: number;
    repeat?: boolean;
    startFrom?: number;
    startMuted?: boolean;
}

const DEFAULT_VIDEO_OPTIONS: Partial<VideoTypes.CombinedPlaylistPlayerOptions> =
    {
        controls: true,
        module_ad_player: "disabled",
        use_google_tag_manager: true,
        video_autoplay_on_page: true,
        use_title_bar: false,
        useFoundationLayout: true,
        pauseOnBlur: false,
        use_share_overlay: true,
        serviceEnv: "production",
        repeat: true,
    };

export const DEFAULT_CONTEXT_OPTIONS: VideoPlayerContext = {
    startMuted: true,
    env: parseVideoEnv(),
    loadSuggestions: true,
    options: {
        ...DEFAULT_VIDEO_OPTIONS,
    },
};

export const VideoPlayerContext = createContext<VideoPlayerContext>(
    DEFAULT_CONTEXT_OPTIONS
);
